// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3888":"30355318f389b6ca","6429":"ac54435b2d4bb5d3","6822":"6b581221c8cf596a"}[chunkId] + ".css";
};